import React from 'react';

import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../ContactModal";

function Main3() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content page-lahalle" style={{background: '#E7ECFF80', position: 'relative', overflow: 'visible'}}>
                <div className="auto-container">
                    <div className="row grid-base align-items-center g-5">
                        <div className="image-column -no-margin col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <figure className="image-box image-responsive">
                                <img src="/images/lahalle/femme.webp" alt="opératrice" style={{position: 'initial'}} />
                            </figure>
                        </div>
                        <div className="content-column col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <div className="wow fadeInLeft">
                                <div className="sec-title raleway">
                                    <h2 className="fw-700">L’intérêt <span> pour vous ?</span></h2>
                                </div>
                                <div className="text nunito">
                                    Ce service vous permet de :
                                    <div className="text mt-3 mb-3">
                                        <ul className="list-style-disc">
                                            <li>
                                                <strong>Vous informer sur le handicap et sur vos droits</strong>, et répondre à vos questions de manière confidentielle, concrète et personnalisée
                                            </li>
                                            <li>
                                                <strong>Bien prendre en compte le handicap</strong> pour faciliter et favoriser le maintien dans l’emploi ou les reconversions de manière équitable et en phase avec vos besoins
                                            </li>
                                            <li>
                                                <strong>Favoriser un environnement de travail</strong> propice à la santé, au bien-être et à l’épanouissement de chacun
                                            </li>
                                        </ul>
                                    </div>
                                    Vous pouvez échanger sur rendez-vous avec un expert <b>à votre rythme, et selon votre situation.</b>
                                </div>

                                <ContactModal
                                    textButton="Réserver mon RDV"
                                    showText={false}
                                    small="small"
                                    linkPageContact={false}
                                    iframe={true}
                                    couleur={false}
                                    page="lahalle"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Main3;
